"use strict";

// Periodos 'YYYY-MM' de los archivos por obligacion. Nombres de mes propios y
// no el locale de moment: el front no lo carga y saldrian en ingles.
const MONTH_NAMES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const pad = n => (n < 10 ? `0${n}` : String(n));

export const currentPeriod = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}`;
};

// delta en meses, positivo o negativo, cruzando de anio.
export const shiftPeriod = (period, delta) => {
  const [year, month] = period.split("-").map(Number);
  const shifted = new Date(year, month - 1 + delta, 1);
  return `${shifted.getFullYear()}-${pad(shifted.getMonth() + 1)}`;
};

export const periodLabel = period => {
  const [year, month] = period.split("-").map(Number);
  return `${MONTH_NAMES[month - 1]} ${year}`;
};

// La MISMA clave que arma el backend en obligation-file-validation.js. Si
// divergen, el menu dice "Cargar archivo" para una obligacion con archivos.
export const fileKey = obligation =>
  obligation.referenceId ? `${obligation._id}|${obligation.referenceId}` : String(obligation._id);

const CYCLE_MONTHS = { monthly: 1, bimonthly: 2, quarterly: 3, biannual: 6, annual: 12 };

// Si hay un archivo del ciclo vigente: desde un ciclo antes del vencimiento.
// Sin ciclo fijo (una vez, fecha limite) alcanza con tener alguno.
export const hasCurrentFile = (entry, obligation) => {
  if (!entry || !entry.count || !obligation.dueDate) return false;
  const months = CYCLE_MONTHS[obligation.dueDateType];
  if (!months) return true;
  const due = new Date(obligation.dueDate);
  const duePeriod = `${due.getFullYear()}-${pad(due.getMonth() + 1)}`;
  return entry.lastPeriod >= shiftPeriod(duePeriod, -months);
};

export const groupByPeriod = files => {
  const byPeriod = {};
  (files || []).forEach(file => {
    (byPeriod[file.period] = byPeriod[file.period] || []).push(file);
  });
  return Object.keys(byPeriod).sort().reverse().map(period => ({ period, files: byPeriod[period] }));
};

export const formatSize = bytes => {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
};
